import { ACTIONS_FROM_SM } from '../../constants.js';

export function callType(type) {
  return {
    type: ACTIONS_FROM_SM.CALL_TYPE,
    callType: type
  };
}

export function messageFromSupervisor(message, supervisor) {
  return {
    type: ACTIONS_FROM_SM.MESSAGE_FROM_SUPERVISOR,
    message: message,
    supervisor: supervisor,
  };
}

export function agentUnavailableOnTransfer(message) {
  return {
    type: ACTIONS_FROM_SM.NO_AVAILABLE_INFO,
    message: message,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_actions_from_SM.js